import { isEmpty } from "@/utils/ArrayUtils.js";

export const PERMISSOES = {
	ACESSO_TOTAL: "ACESSO_TOTAL",
	VISUALIZAR_PAINEL_ADMIN: "VISUALIZAR_PAINEL_ADMIN",
	GERENCIAR_ACESSOS: "GERENCIAR_ACESSOS",
	VISUALIZAR_SOLICITACOES: "VISUALIZAR_SOLICITACOES",
	RESPONDER_SOLICITACOES: "RESPONDER_SOLICITACOES",
	VISUALIZAR_EMPRESAS: "VISUALIZAR_EMPRESAS",
	GERENCIAR_SELOS: "GERENCIAR_SELOS",
};

export const PERMISSOES_FGTAS = {
	ACESSO_TOTAL: "ACESSO_TOTAL",
	VISUALIZAR_PAINEL_ADMIN: "VISUALIZAR_PAINEL_ADMIN",
	GERENCIAR_ACESSOS: "GERENCIAR_ACESSOS",
	CADASTRAR_VAGA: "CADASTRAR_VAGA",
	ACOMPANHAR_VAGA: "ACOMPANHAR_VAGA",
	CANCELAR_VAGA: "CANCELAR_VAGA",
	ANALISAR_VAGA: "ANALISAR_VAGA",
	VISUALIZAR_SOLICITACAO_VAGA: "VISUALIZAR_SOLICITACAO_VAGA",
	CADASTRAR_ATENDIMENTO: "CADASTRAR_ATENDIMENTO",
	VISUALIZAR_ATENDIMENTO: "VISUALIZAR_ATENDIMENTO",
};

export const usuarioPossuiPermissao = (usuario, permissao) => {
	if (usuario == null || isEmpty(usuario.permissoes)) {
		return false;
	}
	if (usuario.permissoes.includes(PERMISSOES_FGTAS.ACESSO_TOTAL)) {
		return true;
	}
	return usuario.permissoes.includes(permissao);
};
